import React from 'react'
// components
import ApiClientsTable from './components/Table'
import ApiClientCreateModal from 'components/Modals/ApiClientCreateModal'
import ApiClientSecretModal from 'components/Modals/ApiClientSecretModal'
import ApiClientUpdateModal from 'components/Modals/ApiClientUpdateModal'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
// constants
import { API_DOCS_URL } from 'constants/apiClient'
// views
import { Intro, DocsLink } from './views'

const ApiClients: React.FC = () => {
  return (
    <>
      <Intro>
        <span>
          Authenticate with OAuth 2.0 client credentials - exchange your Client ID and Secret for an access token.
        </span>
        <DocsLink href={API_DOCS_URL} target='_blank' rel='noopener noreferrer'>
          API Documentation
        </DocsLink>
      </Intro>

      <ApiClientsTable />

      <ApiClientCreateModal />
      <ApiClientSecretModal />
      <ApiClientUpdateModal />
      <ConfirmDeleteModal header='Revoke API Client'>
        Revoking is permanent. The client will be deactivated immediately and can no longer be used.
      </ConfirmDeleteModal>
    </>
  )
}

export default ApiClients
